export function formatGBP(pence: number | null | undefined) {
  const p = pence ?? 0;
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: p % 100 === 0 ? 0 : 2,
  }).format(p / 100);
}

export function poundsToPence(pounds: number) {
  return Math.round(pounds * 100);
}

export function timeLeft(endIso: string): { text: string; ended: boolean; urgent: boolean } {
  const ms = new Date(endIso).getTime() - Date.now();
  if (ms <= 0) return { text: "Ended", ended: true, urgent: false };
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  let text: string;
  if (d > 0) text = `${d}d ${h}h`;
  else if (h > 0) text = `${h}h ${m}m`;
  else if (m > 0) text = `${m}m ${sec}s`;
  else text = `${sec}s`;
  return { text, ended: false, urgent: ms < 60 * 60 * 1000 };
}

export const CONDITION_LABEL: Record<string, string> = {
  pristine: "Pristine",
  mint: "Mint",
  near_mint: "Near Mint",
  excellent: "Excellent",
  good: "Good",
  light_played: "Light Played",
  played: "Played",
  poor: "Poor",
  fair: "Fair",
};
